import { DocumentNode, gql } from '@apollo/client';
export const OnGenerateReportPDFRequest: DocumentNode = gql`
    subscription OnGenerateReportPDFRequest($ID: ID!) {
        onGenerateReportPDFRequest(ID: $ID) {
            ID
            Status
            url
        }
    }
`;
